import { useMutation } from 'react-query';
import { stripeError } from 'Core/utils/stripe';

export default function useConfirmPayment() {
  return useMutation(async ({ stripe, elements, returnUrl, billingDetails }) => {
    const confirmParams = { return_url: returnUrl };
    if (billingDetails) {
      confirmParams.payment_method_data = { billing_details: billingDetails };
    }
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams,
      redirect: 'if_required',
    });
    if (error) {
      throw stripeError(error);
    }
    return { status: paymentIntent?.status };
  });
}
